import React from 'react';

import Table from 'components/Table';
import Money from 'components/Money';

import './styles.css';

const CreditNoteItemsTable = ({creditNote}) => {
  return (
    <div className="CreditNoteItemsTable">
      <Table>
        <Table.Header>
          <Table.HeaderItem heading="Description" className="description" />
          <Table.HeaderItem heading="QTY" className="quantity" />
          <Table.HeaderItem heading="Unit price" className="unitPrice" />
          <Table.HeaderItem heading="Tax rate" className="taxRate" />
          <Table.HeaderItem heading="Amount GBP" className="amount" />
        </Table.Header>
        <Table.Body>
          {creditNote.items.map((item, index) => {
            return (
              <Table.Row key={index}>
                <Table.Cell>{item.description}</Table.Cell>
                <Table.Cell>{item.quantity}</Table.Cell>
                <Table.Cell>
                  <Money amount={item.unitPriceExcludingTax} />
                </Table.Cell>
                <Table.Cell>{item.taxRate}</Table.Cell>
                <Table.Cell>
                  <Money amount={item.lineAmount} />
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default CreditNoteItemsTable;
